import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
import { getConfig } from '@superbet-group/web.lib.config';

export const sbMetaAttribute = 'data-sb-meta';
export const timeFilterSlug = `:timeFilter(${Object.values(TimeFilterSlug).join('|')}|20\\d{2}-\\d{2}-\\d{2})`;
export const calendarGamePath = getConfig().calendarGame.calendarGameWebPath;
